const Influencers = {
  followTheSteps: 'Siga los pasos para realizar',
  InfluencerStep1: 'Tener por lo menos 300.000 seguidores.',
  InfluencerStep2:
    'Envía tu correo electrónico y tu URL de regalo a nuestro Instagram @instasorteioo a través de tu perfil.',
  InfluencerStep3: 'Espera a que se autorice tu sorteo (24 horas laborables).',
};

export default Influencers;
